
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merchant-processing",
      function () {
        return require("private-next-pages/merchant-processing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merchant-processing"])
      });
    }
  